import React, { useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function CustomCursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 300, damping: 28, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 300, damping: 28, mass: 0.5 });

  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, [x, y]);

  if (typeof window !== 'undefined' &&
      window.matchMedia('(pointer: coarse)').matches) return null;

  return (
    <motion.div
      style={{
        position: 'fixed',
        top: 0, left: 0,
        x: sx, y: sy,
        translateX: '-50%',
        translateY: '-50%',
        width: 10, height: 10,
        borderRadius: '50%',
        border: '1.5px solid rgba(255,255,255,0.8)',
        background: 'transparent',
        zIndex: 9999,
        pointerEvents: 'none',
        mixBlendMode: 'difference',
      }}
      aria-hidden="true"
    />
  );
}
